// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__M2mkS","table__container":"styles_table__container__2X16A","sortable":"styles_sortable__3iiY7"};